export default __webpack_public_path__ + "static/linkBg4_shadow-99d032ea530d7773bbb3b09d1ce559c3.png";